import { ReactNode, Suspense, lazy } from 'react';

import {
  ExtensionDefinition,
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';

const LazyLayout = lazy(() =>
  import('../Layout/Layout').then(m => ({ default: m.Layout })),
);
const LazySidebarMenu = lazy(() =>
  import('./SidebarMenu').then(m => ({
    default: m.SidebarMenu,
  })),
);

const LayoutContent = ({ content }: { content: ReactNode }) => {
  return (
    <Suspense fallback={null}>
      <LazyLayout nav={<LazySidebarMenu />} content={content} />
    </Suspense>
  );
};

export const Layout = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  *factory({ inputs }) {
    yield coreExtensionData.reactElement(
      <LayoutContent
        content={inputs.content.get(coreExtensionData.reactElement)}
      />,
    );
  },
}) as ExtensionDefinition;
